import React from 'react'
import { BiLogoTelegram } from 'react-icons/bi'
import { FaDiscord, FaXTwitter } from 'react-icons/fa6'
import hmCoin from '../Images/hamster-coin.webp'
import { MdOutlineArrowOutward } from 'react-icons/md'
import icon5 from '../Images/5.png'
import bg1 from '../Images/hamster-bg-1.png'
import icon9 from '../Images/9.png'
import bg2 from '../Images/hamster-bg-2.png'
import Binance from '../Images/binance.png'
import Bybit from '../Images/bybit.avif'
import bingX from '../Images/bingX.png'
import htx from '../Images/htx.jpg'
import kucoin from '../Images/Kucoin.png'
import gate from '../Images/gate.png'
import mexc from '../Images/mexc.png'
import bitget from '../Images/bitget.png'
import { FaTelegramPlane } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'


export default function Page() {

    const navigate = useNavigate()

    const openPDF = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/hamster-kombat-clone-dab00.appspot.com/o/PDF%2Fhamster_kombat_me_whitepaper.pdf?alt=media&token=0992b03c-c980-44fc-b3dc-b228d03e85de'
    }
    const goToTwitter = () => {
        window.location.href = "https://x.com/HKombat_coin?t=PM4qOLqo8Rd1kbENmXYMNg&s=09"
    }
    const goToTg = () => {
        window.location.href = "https://t.me/hamster_kombat_game_coin"
    }
    return (
        <>
            <div className='container-fluid text-white'>
                <div className="upper-nav d-flex justify-content-between flex-wrap">
                    <div className="join-us-icon">
                        <div className="join-us-btn d-flex align-items-center w-100 justify-content-between ">
                            <div className="join-btn" onClick={goToTwitter}>
                                <FaXTwitter className='btn-icon' />
                            </div>
                            <div className="join-btn" onClick={goToTg}>
                                <BiLogoTelegram className='btn-icon' />
                            </div>
                            <h6 className='dull-text m-0'>Join us!</h6>
                        </div>
                    </div>
                    <div className="center-heading">
                        <div className="heading-img-div">
                            <img src={hmCoin} width={100} alt="" />
                        </div>
                        <div>
                            <h3 className='text-center m-0'>Hmaster Kombat</h3>
                            <h3 className='text-center m-0'>Coin</h3>
                        </div>
                    </div>
                    <div className="whitepaper">
                        <div className="whitepaper-btn mt-4" onClick={openPDF}>
                            <h6 className='m-0'>Whitepaper</h6>
                            <MdOutlineArrowOutward />
                        </div>
                        <span className='whitepaper-comming-soon cursor-pointer' onClick={() => navigate('/tasks')}>Daily Tasks</span>
                    </div>
                </div>
                <div className="home-page mt-3">
                    <h1 className='main-heading'>Unleash your inner CEO</h1>
                    <div className='main-coin-icon'>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={Binance} className='img-fluid' alt="" />
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 -0.001 157.427 44.186"><path fill="#fff" d="M46.17 0H1.05C.77 0 .503.103.306.288A.951.951 0 0 0 0 .982v42.22c0 .26.11.51.307.694s.464.288.742.288H46.17c.279 0 .545-.104.743-.288a.952.952 0 0 0 .307-.694V.982a.95.95 0 0 0-.307-.694A1.088 1.088 0 0 0 46.17 0zM31.48 28.474c0 .26-.11.51-.308.694a1.087 1.087 0 0 1-.741.288H16.789c-.278 0-.545-.104-.742-.288a.951.951 0 0 1-.307-.694V15.71c0-.26.11-.51.307-.694.197-.185.464-.288.742-.288h13.642c.278 0 .545.103.741.288a.95.95 0 0 1 .308.694zM140.63 14.73h-13.642c-.58 0-1.05.44-1.05.982v12.764c0 .542.47.982 1.05.982h13.641c.58 0 1.05-.44 1.05-.982V15.712c0-.543-.47-.982-1.05-.982zM124.893 0h-13.641c-.58 0-1.05.44-1.05.983v12.764c0 .542.47.982 1.05.982h13.64c.58 0 1.05-.44 1.05-.982V.983c0-.543-.47-.982-1.05-.982zm31.485 0h-13.642c-.579 0-1.049.44-1.049.983v12.764c0 .542.47.982 1.05.982h13.64c.58 0 1.05-.44 1.05-.982V.983c0-.543-.47-.982-1.05-.982zm-31.485 29.457h-13.641c-.58 0-1.05.44-1.05.982v12.765c0 .542.47.981 1.05.981h13.64c.58 0 1.05-.44 1.05-.981V30.439c0-.542-.47-.982-1.05-.982zm31.485 0h-13.642c-.579 0-1.049.44-1.049.982v12.765c0 .542.47.981 1.05.981h13.64c.58 0 1.05-.44 1.05-.981V30.439c0-.542-.47-.982-1.05-.982zM101.264 0h-13.64c-.58 0-1.05.44-1.05.983v12.764c0 .542.47.982 1.05.982h13.64c.58 0 1.05-.44 1.05-.982V.983c0-.543-.47-.982-1.05-.982zm0 29.457h-13.64c-.58 0-1.05.44-1.05.982v12.765c0 .542.47.981 1.05.981h13.64c.58 0 1.05-.44 1.05-.981V30.439c0-.542-.47-.982-1.05-.982zM86.57 15.699c0-.26-.112-.51-.308-.695a1.087 1.087 0 0 0-.742-.287H70.829V.982a.95.95 0 0 0-.307-.694A1.087 1.087 0 0 0 69.78 0H56.139c-.279 0-.546.103-.743.288a.951.951 0 0 0-.307.694V43.18c0 .26.11.51.307.694s.464.288.743.288h13.64c.279 0 .546-.104.743-.288s.307-.434.307-.694V29.445h14.69c.279 0 .546-.104.743-.288a.952.952 0 0 0 .307-.694z"></path></svg>
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_6050_2160)">
                                        <path d="M19.4975 39.995L2 29.9975V10.0025L19.4975 0.00503559L36.9949 10.0025V29.9975L19.4975 39.995ZM3.2672 29.2748L19.4975 38.5462L35.7277 29.2714V10.7252L19.4975 1.4538L3.27058 10.7286V29.2748H3.2672Z" fill="white"></path>
                                        <path d="M26.1544 31.744H23.7551L20.8828 29.1342V27.7959L23.8565 24.9853V20.5353L27.7426 18.0259L32.1693 21.3383L26.1544 31.744Z" fill="white"></path>
                                        <path d="M19.4648 24.7177H16.2208L16.6601 20.5353L15.207 16.7879H23.7902L22.3709 20.5353L22.7764 24.7177H19.4648Z" fill="white"></path>
                                        <path d="M18.1783 29.1342L15.306 31.7775H12.873L6.82422 21.3383L11.2848 18.0594L15.2046 20.5353V24.9853L18.1783 27.7959V29.1342Z" fill="white"></path>
                                        <path d="M12.8396 9.05897H26.1198L27.708 15.7507H11.2852L12.8396 9.05897Z" fill="white"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6050_2160">
                                            <rect width="35" height="40" fill="white" transform="translate(2)"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={Bybit} className='img-fluid' alt="" />
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={bingX} className='img-fluid' alt="" />
                            </div>
                        </div>
                        {/* <div className='coin-icon'>
                            <div className='coin'>
                                <img src={htx} className='img-fluid' alt="" />
                            </div>
                        </div> */}
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={kucoin} className='img-fluid' alt="" />
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={gate} className='img-fluid' alt="" />
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={mexc} className='img-fluid' alt="" />
                            </div>
                        </div>
                        <div className='coin-icon'>
                            <div className='coin'>
                                <img src={bitget} className='img-fluid' alt="" />
                            </div>
                        </div>
                    </div>
                    <p className='text-center home-desc'>Make your way from the shaved hamster to the grandmaster CEO of the tier-1 crypto exchange</p>
                    <p className='text-center home-desc d-md-block d-none'>Buy upgrades, complete quests, invite friends and become the best</p>
                    <div className="main-btn">
                        <a className='btn-glow' href='https://dedust.io/swap/TON/EQADj83n6OASbaht6yf_VR8hamNurbkPY4gRoQAm-7Acz3y4?amount=1000000000'>
                            <span>Buy now</span>
                        </a>
                    </div>
                </div>
                <h1 className="roadmap">Roadmap</h1>
                <div className="roadmap-inner">
                    <div className="roadmap-item is-completed">
                        <div className="roadmap-title">
                            <p className='m-0'>March 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li className="list-completed">Baic game</li>
                                <li className="list-completed">Mining updates</li>
                                <li className="list-completed">Earn tasks</li>
                            </ul>
                        </div>
                    </div>
                    <div className="roadmap-item is-completed">
                        <div className="roadmap-title">
                            <p className='m-0'>April 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li className="list-completed">Referral system</li>
                                <li className="list-completed">LVL ratings</li>
                                <li className="list-completed"> Daily rewards</li>
                            </ul>
                        </div>
                        <div className="roadmap-hamster is-1">
                            <div className="roadmap-hamster-bg">
                                <img src={bg1} alt="" />
                            </div>
                            <div className="roadmap-hamster-image">
                                <picture className='is-hamster-imgage'>
                                    <img src={icon5} className='img-responsive' alt="" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="roadmap-item is-completed">
                        <div className="roadmap-title">
                            <p className='m-0'>May 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li className="list-completed">Special cards</li>
                                <li className="list-completed">Daily Combo</li>
                                <li className="list-completed"> «Partner» blockchain announcement</li>
                            </ul>
                        </div>
                    </div>
                    <div className="roadmap-item is-completed">
                        <div className="roadmap-title">
                            <p className='m-0'>June 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li className="list-completed">On-chain infrastructure development</li>
                                <li className="list-completed">Wallet in-game implementation</li>
                                <li className="list-completed">Web 3 pre-listing Quest</li>
                            </ul>
                        </div>
                    </div>
                    <div className="roadmap-item is-completed">
                        <div className="roadmap-title">
                            <p className='m-0'>July 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li className="list-completed">TGE</li>
                                <li className="list-completed">Token in-game utility launch</li>
                            </ul>
                        </div>
                    </div>
                    <div className="roadmap-item">
                        <div className="roadmap-title">
                            <p className='m-0'>Q3 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li>Squad Kombat</li>
                                <li>Characters and skins</li>
                                <li>Time limited events</li>
                                <li>Live events</li>
                            </ul>
                        </div>
                    </div>
                    <div className="roadmap-item">
                        <div className="roadmap-title">
                            <p className='m-0'>Q4 2024</p>
                        </div>
                        <div className="roadmap-content">
                            <ul className='m-0'>
                                <li>Many more, we’ll keep in secret not to spoil your excitement</li>
                            </ul>
                        </div>
                        <div className="roadmap-hamster is-2">
                            <div className="roadmap-hamster-bg bottom-bg">
                                <img src={bg2} alt="" />
                            </div>
                            <div className="roadmap-hamster-image">
                                <picture className='is-hamster-imgage'>
                                    <img src={icon9} className='img-responsive' alt="" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="footer-social">
                        <a className='is-discord'>
                            <div className="icon">
                                <FaDiscord style={{ width: 30 }} />
                            </div>
                        </a>
                        <a className='is-telegram' href=''>
                            <div className="icon">
                                <FaTelegramPlane style={{ width: 30 }} />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}
